import { Button, Card, CardActions, CardMedia, Container, Grid2} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { LocationOn } from "@mui/icons-material";
import { PartnerApplicationModel } from "../models/PartnerApplicationModel";
import { WebStorageService } from "../services/WebStorageService";
import { useEffect } from "react";
import { Utils } from "../helpers/utils";
import { DEFAULT_STOREID, PARTNERSHIP } from "../contants/constants";

export default function PartnershipProgramBecomeOurPartner() {
    const { storeID } = useParams();
    const webStorageService = new WebStorageService();

    const navigate = useNavigate();

    let partnerApplication: PartnerApplicationModel = webStorageService.getJson(PARTNERSHIP) || new PartnerApplicationModel({BusinessName:'',Address:'',FirstName:'',LastName:'',Mobile1:'',PartnerApplicationID:0});
    
    useEffect(() => {
        if(Utils.isNotNullOrEmpty(storeID))
            partnerApplication.StoreID = Number(storeID);
        else if(Utils.isNullOrEmpty(partnerApplication.StoreID))
            partnerApplication.StoreID = Number(storeID || DEFAULT_STOREID);
        webStorageService.setJson(PARTNERSHIP, partnerApplication);
    });

    return (
        <Container>
            <Card sx={{ textAlign: "center", background: "#FEF9F8", marginX: "auto", width: "100%", boxShadow: "none", marginTop:{ xs: 10, sm: 10, md: 10}}}>
                <CardMedia sx={{ height: {xs:300, sm:550, md:550, lg:650}, marginBottom: 3 }} image="/partnership-program-handling-discount-voucher.jpg" />

                <Grid2 container spacing={2} sx={{fontSize: {xs: 12, sm: 12, md: 14}, fontFamily: "Roboto, Helvetica,Arial, sans-serif"}}>
                    <Grid2 size={{ xs:4, sm:4, md:4, lg:4 }} sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <LocationOn color="primary"></LocationOn> Quezon City
                    </Grid2>
                    <Grid2 size={{ xs:4, sm:4, md:4, lg:4 }} sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <LocationOn color="warning"></LocationOn> Marikina City
                    </Grid2>
                    <Grid2 size={{ xs:4, sm:4, md:4, lg:4 }} sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <LocationOn color="success"></LocationOn> San Mateo
                    </Grid2>
                </Grid2>

                <CardActions sx={{ display: "flex", justifyContent: "center", marginBottom: 1, marginTop: 3, paddingX: 0 }}>
                    <Button variant="contained" sx={{ background: "#d32f2f", width:{ xs: '100%', sm: '100%', md: 'auto' } }} onClick={()=>navigate("/partnership-program-step1")} size="large">GUSTO KO MAGING PARTNER AT KUMITA</Button>
                </CardActions>

            </Card>
        </Container>
    );
}
